import * as React from 'react'

const SvgUserAvatarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM6.25 16.488v-1.25a2.012 2.012 0 011.875-2.113h3.75a2.012 2.012 0 011.875 2.119v1.25a7.45 7.45 0 01-7.5 0v-.006zm8.75-.913v-.381a3.256 3.256 0 00-3.125-3.319h-3.75A3.25 3.25 0 005 15.194v.368a7.5 7.5 0 1110 0v.013zm-5-11.2a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25zm0 5a1.875 1.875 0 110-3.75 1.875 1.875 0 010 3.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgUserAvatarIcon
